import { Union, Record } from "../fable-library-js.4.24.0/Types.js";
import { array_type, int32_type, union_type, lambda_type, unit_type, bool_type, obj_type, class_type, string_type, record_type, float64_type } from "../fable-library-js.4.24.0/Reflection.js";

export class Props_Point2 extends Record {
    constructor(x, y) {
        super();
        this.x = x;
        this.y = y;
    }
}

export function Props_Point2_$reflection() {
    return record_type("Fable.Recharts.Props.Point2", [], Props_Point2, () => [["x", float64_type], ["y", float64_type]]);
}

export class Props_Point3 extends Record {
    constructor(x, y, z) {
        super();
        this.x = x;
        this.y = y;
        this.z = z;
    }
}

export function Props_Point3_$reflection() {
    return record_type("Fable.Recharts.Props.Point3", [], Props_Point3, () => [["x", float64_type], ["y", float64_type], ["z", float64_type]]);
}

export class Props_LinePoint extends Record {
    constructor(x, y, value) {
        super();
        this.x = x;
        this.y = y;
        this.value = value;
    }
}

export function Props_LinePoint_$reflection() {
    return record_type("Fable.Recharts.Props.LinePoint", [], Props_LinePoint, () => [["x", float64_type], ["y", float64_type], ["value", float64_type]]);
}

export class Props_ScatterPoint extends Record {
    constructor(cx, cy, r, payload) {
        super();
        this.cx = cx;
        this.cy = cy;
        this.r = r;
        this.payload = payload;
    }
}

export function Props_ScatterPoint_$reflection() {
    return record_type("Fable.Recharts.Props.ScatterPoint", [], Props_ScatterPoint, () => [["cx", float64_type], ["cy", float64_type], ["r", float64_type], ["payload", Props_Point3_$reflection()]]);
}

export class Props_Margin extends Record {
    constructor(top, bottom, right, left) {
        super();
        this.top = top;
        this.bottom = bottom;
        this.right = right;
        this.left = left;
    }
}

export function Props_Margin_$reflection() {
    return record_type("Fable.Recharts.Props.Margin", [], Props_Margin, () => [["top", float64_type], ["bottom", float64_type], ["right", float64_type], ["left", float64_type]]);
}

export class Props_ViewBox extends Record {
    constructor(x, y, width, height) {
        super();
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}

export function Props_ViewBox_$reflection() {
    return record_type("Fable.Recharts.Props.ViewBox", [], Props_ViewBox, () => [["x", float64_type], ["y", float64_type], ["width", float64_type], ["height", float64_type]]);
}

export class Props_Chart extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SyncId", "Layout", "Width", "Height", "Data", "Margin", "BarCategoryGap", "BarGap", "BarSize", "MaxBarSize", "StackOffset", "BaseValue", "baseValue", "ReverseStackOrder", "Cx", "Cy", "StartAngle", "EndAngle", "InnerRadius", "OuterRadius", "OnClick", "OnMouseDown", "OnMouseUp", "OnMouseMove", "OnMouseOver", "OnMouseEnter", "OnMouseLeave"];
    }
}

export function Props_Chart_$reflection() {
    return union_type("Fable.Recharts.Props.Chart", [], Props_Chart, () => [[["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", class_type("System.Array")]], [["Item", Props_Margin_$reflection()]], [["Item", obj_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]], [["Item", lambda_type(obj_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type))]]]);
}

export class Props_Treemap extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Width", "Height", "Data", "DataKey", "AspectRatio", "IsAnimationActive", "AnimationBegin", "AnimationDuration", "AnimationEasing"];
    }
}

export function Props_Treemap_$reflection() {
    return union_type("Fable.Recharts.Props.Treemap", [], Props_Treemap, () => [[["Item", float64_type]], [["Item", float64_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]]]);
}

export class Props_Responsive extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Aspect", "Width", "Height", "MinWidth", "MinHeight", "Debounce"];
    }
}

export function Props_Responsive_$reflection() {
    return union_type("Fable.Recharts.Props.Responsive", [], Props_Responsive, () => [[["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]]]);
}

export class Props_Legend extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Width", "Height", "Layout", "Align", "VerticalAlign", "IconSize", "IconType", "PayLoad", "ChartWidth", "ChartHeight", "Margin", "Content", "WrapperStyle", "OnClick", "OnMouseDown", "OnMouseUp", "OnMouseMove", "OnMouseOver", "OnMouseEnter", "OnMouseLeave"];
    }
}

export function Props_Legend_$reflection() {
    return union_type("Fable.Recharts.Props.Legend", [], Props_Legend, () => [[["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", class_type("System.Array")]], [["Item", float64_type]], [["Item", float64_type]], [["Item", Props_Margin_$reflection()]], [["Item", obj_type]], [["Item", obj_type]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]]]);
}

export class Props_Tooltip extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Separator", "Offset", "ItemStyle", "WrapperStyle", "LabelStyle", "Cursor", "ViewBox", "Active", "Coordinate", "Payload", "Label", "Content", "Formatter", "LabelFormatter", "ItemSorter", "IsAnimationActive", "AnimationBegin", "AnimationDuration", "AnimationEasing"];
    }
}

export function Props_Tooltip_$reflection() {
    return union_type("Fable.Recharts.Props.Tooltip", [], Props_Tooltip, () => [[["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", Props_ViewBox_$reflection()]], [["Item", bool_type]], [["Item", Props_Point2_$reflection()]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]]]);
}

export class Props_Cell extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Fill", "Stroke"];
    }
}

export function Props_Cell_$reflection() {
    return union_type("Fable.Recharts.Props.Cell", [], Props_Cell, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class Props_Text extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ScaleToFit", "Angle", "Width", "TextAnchor", "VerticalAnchor"];
    }
}

export function Props_Text_$reflection() {
    return union_type("Fable.Recharts.Props.Text", [], Props_Text, () => [[["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class Props_Label extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ViewBox", "Formatter", "Value", "Position", "Offset", "Children", "Content", "Id"];
    }
}

export function Props_Label_$reflection() {
    return union_type("Fable.Recharts.Props.Label", [], Props_Label, () => [[["Item", Props_ViewBox_$reflection()]], [["Item", lambda_type(obj_type, obj_type)]], [["Item", obj_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", string_type]]]);
}

export class Props_LabelList extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DataKey", "ValueAccessor", "Content", "Position", "Offset", "Formatter", "Data", "ClockWise", "Id"];
    }
}

export function Props_LabelList_$reflection() {
    return union_type("Fable.Recharts.Props.LabelList", [], Props_LabelList, () => [[["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", lambda_type(obj_type, obj_type)]], [["Item", float64_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class Props_Cartesian extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Type", "Data", "DataKey", "LegendType", "Label", "Stroke", "StrokeWidth", "Layout", "BaseLine", "Unit", "Name", "Id", "StackId", "IsAnimationActive", "AnimationBegin", "AnimationDuration", "AnimationEasing", "Dot", "ActiveDot", "Points", "ConnectNulls", "BarSize", "MaxBarSize", "MinPointSize", "Background", "Shape", "Line", "LineType", "Hide", "Width", "Height", "XAxisId", "YAxisId", "ZAxisId", "Range", "AxisLine", "Orientation", "AllowDecimals", "AllowDataOverflow", "AllowDuplicatedCategory", "MinTickGap", "TickCount", "TickSize", "TickLine", "TickMargin", "TickFormatter", "Ticks", "Tick", "Domain", "Interval", "Padding", "Mirror", "Reversed", "Scale", "X", "Y", "X1", "X2", "Y1", "Y2", "TravellerWidth", "StartIndex", "EndIndex", "ViewBox", "Horizontal", "Vertical", "HorizontalPoints", "VerticalPoints", "XAxis", "YAxis", "AlwaysShow", "IsFront", "Direction", "OnChange", "OnClick", "OnMouseDown", "OnMouseUp", "OnMouseOver", "OnMouseOut", "OnMouseEnter", "OnMouseMove", "OnMouseLeave"];
    }
}

export function Props_Cartesian_$reflection() {
    return union_type("Fable.Recharts.Props.Cartesian", [], Props_Cartesian, () => [[["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", Props_ViewBox_$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", class_type("System.Array")]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]]]);
}

export class Props_Polar extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Cx", "Cy", "InnerRadius", "OuterRadius", "StartAngle", "EndAngle", "MinAngle", "PaddingAngle", "NameKey", "ActiveIndex", "ActiveShape", "PolarAngles", "PolarRadius", "GridType", "Angle", "Type", "Data", "DataKey", "LegendType", "Label", "LabelLine", "IsAnimationActive", "AnimationBegin", "AnimationDuration", "AnimationEasing", "Dot", "Points", "Background", "Shape", "AxisLine", "Orientation", "AllowDuplicatedCategory", "TickCount", "TickLine", "TickFormatter", "Ticks", "Tick", "Domain", "Scale", "OnClick", "OnMouseDown", "OnMouseUp", "OnMouseOver", "OnMouseOut", "OnMouseEnter", "OnMouseMove", "OnMouseLeave"];
    }
}

export function Props_Polar_$reflection() {
    return union_type("Fable.Recharts.Props.Polar", [], Props_Polar, () => [[["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", array_type(int32_type)]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", class_type("System.Array")]], [["Item", string_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", obj_type]], [["Item", class_type("System.Array")]], [["Item", string_type]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]], [["Item", lambda_type(obj_type, lambda_type(int32_type, lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)))]]]);
}

export class Props_Shape {
    constructor() {
    }
}

export function Props_Shape_$reflection() {
    return class_type("Fable.Recharts.Props.Shape", undefined, Props_Shape);
}

